import { state } from "./state";

// Per-user, per-project *view* preferences — kept in localStorage so changing them never touches
// the server (mirrors collapse.ts). Covers the tree filters (pinned / hide-done / by-version), the
// Show-columns toggles, and the view mode. The show-* flags still live in the plan too, seeding a
// first-time view; thereafter this localStorage copy wins. Keyed by plan guid (or "local").

const key = (planKey: string) => "mpp:prefs:" + (planKey || "local");

function snapshotPrefs() {
  return {
    view: state.view,
    showPinnedOnly: state.showPinnedOnly,
    hideDone: state.hideDone,
    versionFilter: state.versionFilter,
    showTags: state.showTags,
    showVersions: state.showVersions,
    showComponents: state.showComponents,
    showDone: state.showDone,
    showJira: state.showJira,
    showGantt: state.showGantt,
  };
}

// persist the current view prefs (called each render; skips redundant writes)
let lastKey = "", lastJson = "";
export function persistPrefs(planKey: string): void {
  const k = key(planKey), json = JSON.stringify(snapshotPrefs());
  if (k === lastKey && json === lastJson) return;
  lastKey = k; lastJson = json;
  try { localStorage.setItem(k, json); } catch { /* quota / private mode: ignore */ }
}

// drop a plan's stored view prefs (e.g. when it's removed from the recents list)
export function clearPrefs(planKey: string): void {
  try { localStorage.removeItem(key(planKey)); } catch { /* ignore */ }
}

// hydrate the view prefs from localStorage onto `state` (no-op when nothing stored for this plan)
export function applyStoredPrefs(planKey: string): void {
  let raw: string | null;
  try { raw = localStorage.getItem(key(planKey)); } catch { return; }
  if (raw == null) return;
  let p: any;
  try { p = JSON.parse(raw); } catch { return; }
  if (!p || typeof p !== "object") return;
  if (p.view === "tree" || p.view === "version") state.view = p.view;
  if (typeof p.showPinnedOnly === "boolean") state.showPinnedOnly = p.showPinnedOnly;
  if (typeof p.hideDone === "boolean") state.hideDone = p.hideDone;
  if (typeof p.versionFilter === "string") state.versionFilter = p.versionFilter;
  if (typeof p.showTags === "boolean") state.showTags = p.showTags;
  if (typeof p.showVersions === "boolean") state.showVersions = p.showVersions;
  if (typeof p.showComponents === "boolean") state.showComponents = p.showComponents;
  if (typeof p.showDone === "boolean") state.showDone = p.showDone;
  if (typeof p.showJira === "boolean") state.showJira = p.showJira;
  if (typeof p.showGantt === "boolean") state.showGantt = p.showGantt;
}
